import { IApiResponse } from "clients/AbstractApiClient/IApiResponse";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetBankAccountArgs,
  TGetBankAccountResponse,
} from "./getBankAccount.schema";

export const getBankAccount = (axios: IAxiosInstance) => {
  return async (params: TGetBankAccountArgs) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetBankAccountResponse>
    >(`/bankaccount`, {
      params,
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
